namespace app.pesquisaAvancada {
    "use strict";

    declare var moment;
    
    import IScope = angular.IScope;
    import IDirective = angular.IDirective;
    import IAugmentedJQuery = angular.IAugmentedJQuery;
    import IAttributes = angular.IAttributes;
    import IDirectiveFactory = angular.IDirectiveFactory;
    import IDateLocaleService = angular.material.IDateLocaleProvider;

    interface CriterionValueInputScope extends IScope {
        criterion: Criterion;
        strToDate: Function;
        dateToStr: Function;
        initBetween: Function;
        changeCriteriaValue: Function;
        date: Array<any>;
    }
    
    class CriterionValueInputController {
        
        /** @ngInject **/
        public constructor (private $scope: CriterionValueInputScope, private $mdDateLocale: IDateLocaleService, private $filter: ng.IFilterService, private $rootScope: ng.IScope) {
            
            $scope.$watch("criterion.selectedItem", function() {
                if ($scope.criterion.trait.dataType === "list" && _.isObject($scope.criterion.selectedItem)) {
                    $scope.criterion.display = $scope.criterion.selectedItem.value;
                    $scope.criterion.value = $scope.criterion.selectedItem.id.toString();
                } else if ($scope.criterion.selectedItem === null) {
                    $scope.criterion.display = null;
                    $scope.criterion.value = null;
                }
                CriterionValueInputController.updateCriteriaValidity($scope.criterion);
            });
            
            $scope.$watch("criterion.value[0]", function() {
                CriterionValueInputController.updateCriteriaValidity($scope.criterion);
            });
            
            $scope.$watch("criterion.value[1]", function() {
                CriterionValueInputController.updateCriteriaValidity($scope.criterion);
            });

            $scope.$watch("criterion.comparisonOperator", (op: ComparisonOperator) => {
                let criterion: Criterion = $scope.criterion,
                    value = criterion.value;

                if (op == ComparisonOperator.BETWEEN) {
                    criterion.value = _.isArray(value) ? value : [value];
                } else {
                    criterion.value = _.isArray(value) ? value[0] : value;
                }
                CriterionValueInputController.updateCriteriaValidity(criterion);
            });
        }
        
        public initBetween(index): void {
            let startOfDay: boolean = (index ? false : true);
            this.$scope.date = this.$scope.date || [];
            this.$scope.criterion.value = this.$scope.criterion.value || [];
            this.$scope.date[index] = this.strToDate(this.$scope.criterion.value[index]);
            this.$scope.criterion.value[index] = this.dateToStr(this.$scope.date[index], startOfDay);
        };
        
        public changeCriterionValue(value: string, index: number = null): void  {
            if (index !== null) {
                this.$scope.criterion.value[index] = value;
            } else {
                this.$scope.criterion.value = value;
            }
        }
        
        public strToDate(str: string): Date {
            let m = moment(str, "YYYY-MM-DDTHH:mm:ss", true);
            return (m.isValid() ? m : moment()).toDate();
        }
        
        public dateToStr(date: Date, startOfDay: boolean): string {
            if (date) {
                return (startOfDay ? moment(date).startOf("day") : moment(date).endOf("day")).format("YYYY-MM-DDTHH:mm:ss");
            }
            return;
        }

        public cleanSelection(e) {
            if (!e.charCode) {
                this.$scope.criterion.selectedItem = null;
            }
        }
        
        public ifEnterDoSearch($event): void {
            if ($event.keyCode === 13) {
                this.$rootScope.$broadcast("ui:advancedSearch:doSearch");
            }
        };
        
        public filterItems(items: Array<TraitListItem>, searchText: string): Array<TraitListItem> {
            return this.$filter("accentInsensitiveOrderBy")(this.$filter("accentInsensitiveFilter")(items, searchText), "value");
        }
        
        private static updateCriteriaValidity(criterion: Criterion): void {
            if (criterion.value === undefined && criterion.comparisonOperator !== ComparisonOperator.EXISTS) {
                criterion.valid = false;
                return;
            }
            switch (criterion.comparisonOperator) {
                case ComparisonOperator.EQUALS:
                case ComparisonOperator.CONTAINS:
                case ComparisonOperator.GREATER_THAN:
                case ComparisonOperator.LESS_THAN:
                    if (criterion.trait.dataType == "date") {
                        criterion.valid = (!!criterion.value);
                    } else {
                        criterion.valid = ((!!criterion.value) && (criterion.value.length > 0));
                    }
                    break;

                case ComparisonOperator.BETWEEN:
                    if (criterion.trait.dataType == "date") {
                        criterion.valid = ((!!criterion.value[0]) && (!!criterion.value[1]));
                    } else {
                        criterion.valid = ((!!criterion.value[0]) && (!!criterion.value[1]) &&
                                            (criterion.value[0].length > 0) && (criterion.value[1].length > 0));
                    }
                    break;

                case ComparisonOperator.EXISTS:
                    criterion.valid = true;
                    break;
            }
        }
    }

    class CriterionValueInputDirective implements IDirective {

        public restrict: string = "E";
        public templateUrl: string = "app/main/pesquisa-avancada/directives/criterion-value-input/criterion-value-input.html";
        public scope: Object = {
            criterion : "="
        };
    
        public controller = CriterionValueInputController;
        
        public controllerAs = "vm";

        constructor() {}

        public static factory(): IDirectiveFactory {
            return () => new CriterionValueInputDirective();
        }
    }

    angular
        .module("app.pesquisa-avancada")
        .directive("criterionValueInput", CriterionValueInputDirective.factory());
}